/**
 * Pure component for common multi enum dropdown
 */
import { DefaultItem } from '@adsk/alloy-react-dropdown';
import { CommonFormField } from '../CommonFormField';
import { PureEnumMultiDropdown, PureEnumMultiDropdownProps } from './PureEnumMultiDropdown';

export type PureEnumMultiDropdownFieldProps = {
  fieldName: PureEnumMultiDropdownProps['fieldName'];
  value?: string[];
  onChange: (value: DefaultItem[]) => void;
  id?: string;
  ref?: React.RefObject<HTMLDivElement>;
  label?: string;
  required?: boolean;
  error?: string;
  disabled?: boolean;
  placeholder?: string;
  clearable?: boolean;
};

export const PureEnumMultiDropdownField = ({
  fieldName,
  value,
  onChange,
  id,
  ref,
  label,
  required,
  error,
  disabled,
  placeholder,
  clearable,
}: PureEnumMultiDropdownFieldProps) => (
  <CommonFormField label={label} required={required} error={error} ref={ref}>
    <PureEnumMultiDropdown
      fieldName={fieldName}
      value={value}
      onChange={onChange}
      id={id}
      disabled={disabled}
      placeholder={placeholder}
      clearable={clearable}
    />
  </CommonFormField>
);
